import React, { Fragment, useState } from "react";
import SideBar from "./SideBar";
import NavHader from "./NavHader";
import Header from "./Header";
import ChatBox from "../ChatBox";
import {AppBar, IconButton, Tooltip, useMediaQuery} from "@material-ui/core";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import PerfectScrollbar from "react-perfect-scrollbar";
import avatar from '../../../../images/Siamois/images/Me.jpg'
import {
    Equalizer,
    FavoriteBorderOutlined,
    FlagOutlined,
    Fullscreen,
    FullscreenExit,
    Pause,
    PowerSettingsNew
} from "@material-ui/icons";
import QuestionStats, {RecapitulatifBoxExamen, RecapitulatifBoxRevision} from "../../../Exams/QuestionStats";
import './questionStatsHeader.css'
import BlackLogo from '../../../../images/Siamois/logo/logo-black.svg'
import {Link} from "react-router-dom";
import ToggleDarkModeBtn from "../../../../SubCompounents/DarkModeBtn";
import {useDispatch, useSelector} from "react-redux";
import {togglePauseModal} from "../../../../redux/actions/actions";
import {RecaputalitifRevision} from "../../../Exams/Recapitulatifs";

const JobieNav = ({ title , pathName , ExamsFullScreenHandle }) => {
   const [toggle, setToggle] = useState("");
    const revision=useSelector(state=>state.revision)
    const onClick = (name) => setToggle(toggle === name ? "" : name);
   const dispatch=useDispatch();
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl= useMediaQuery('(min-width:1200px)');
    if(pathName.includes('/registration') || pathName.includes('/login')) return null
    if(pathName.includes('revision')){
       return (
           <Fragment>
                <AppBar className="d-flex flex-row align-items-center " id="questionStatsHeader" style={{backgroundColor : 'var(--navigationBg)' , zIndex : 10}} >
                    <div style={lg ? { position: 'relative', left: '44%'} : null } className="col-5" >
                        <img style={lg ? { height : '3rem'} : null } src={BlackLogo} alt=""/>
                    </div>
                    <div className="col-6 col-lg-7" style={{color : 'black'}}>
                        <ul className="navbar-nav header-right flex-row justify-content-lg-end">
                            <Tooltip title={'Terminer et enregistrer'}>
                                <li className="nav-item dropdown notification_dropdown">
                                    <div className="nav-link">
                                        <ToggleDarkModeBtn  examHeader={true} />
                                    </div>
                                </li>
                            </Tooltip>
                            <Tooltip title={ document.fullscreenElement ? 'Quitter le mode Plein écran' : 'Mode Plein écran'}>
                                <li onClick={()=> document.fullscreenElement ? document.exitFullscreen() :document.documentElement.requestFullscreen()} className="nav-item dropdown notification_dropdown">
                                    <div className="nav-link">
                                        {document.fullscreenElement ? <FullscreenExit style={{fontSize : lg ?20 : 12 , color : '#000'}} /> :  <Fullscreen style={{fontSize : lg ?20 : 12 , color : '#000'}} /> }
                                    </div>
                                </li>
                            </Tooltip>
                            <Tooltip title={'Pause'}>
                                <li className="nav-item dropdown notification_dropdown">
                                    <div onClick={()=>dispatch(togglePauseModal())} className="nav-link">
                                        <Pause style={{fontSize : lg? 20 : 12 , color : '#000'}} />
                                    </div>
                                </li>
                            </Tooltip>
                            {
                                !lg ? (
                                    <Tooltip title={'Afficher les statistiques'}>
                                        <li className="nav-item dropdown notification_dropdown">
                                            <div onClick={!lg ?() => onClick("QuestionStats") : null}  className="nav-link">
                                                <Equalizer style={{fontSize : lg?20:12 }}/>
                                            </div>
                                        </li>
                                    </Tooltip>
                                ) :  null
                            }
                        </ul>
                    </div>
                </AppBar>
               <RecapitulatifBoxRevision actualQuestionIndex={revision.actualQuestionIndex} userScore={revision.userScore} howManyQuestions={revision.data.questions ? revision.data.questions.length : 0} onClick={() => onClick("QuestionStats")} toggle={toggle} />
           </Fragment>
       )
   }else if(pathName.includes('/examen')){
        return (
            <Fragment>
                <AppBar className="d-flex flex-row align-items-center " id="questionStatsHeader" style={{backgroundColor : 'var(--navigationBg)' , zIndex : 10}} >
                    <div style={lg ? { position: 'relative', left: '44%'} : null } className="col-5" >
                        <img style={lg ? { height : '3rem'} : null } src={BlackLogo} alt=""/>
                    </div>
                    <div className="col" style={{color : 'black'}}>
                        <ul className="navbar-nav header-right flex-row justify-content-end">
                            <Tooltip title={'Terminer et enregistrer'}>
                                <li className="nav-item dropdown notification_dropdown">
                                    <div className="nav-link">
                                        <ToggleDarkModeBtn  examHeader={true} />
                                    </div>
                                </li>
                            </Tooltip>
                            <Tooltip title={ document.fullscreenElement ? 'Quitter le mode Plein écran' : 'Mode Plein écran'}>
                                <li onClick={()=> document.fullscreenElement ? document.exitFullscreen() :document.documentElement.requestFullscreen()} className="nav-item dropdown notification_dropdown">
                                    <div className="nav-link">
                                        {document.fullscreenElement ? <FullscreenExit style={{fontSize : lg ?20 : 12 , color : '#000'}} /> :  <Fullscreen style={{fontSize : lg ?20 : 12 , color : '#000'}} /> }
                                    </div>
                                </li>
                            </Tooltip>
                            {
                                !lg ? (
                                    <Tooltip title={'Afficher les statistiques'}>
                                        <li className="nav-item dropdown notification_dropdown">
                                            <div onClick={!lg ?() => onClick("QuestionStats") : null}  className="nav-link">
                                                <Equalizer style={{fontSize : lg?20:12 }}/>
                                            </div>
                                        </li>
                                    </Tooltip>
                                ) :  null
                            }
                        </ul>
                    </div>
                </AppBar>
                <RecapitulatifBoxExamen onClick={() => onClick("QuestionStats")} toggle={toggle} />
            </Fragment>
        )
    }else if (pathName.includes('/payment')){
        return(
            <Fragment>
                <NavHader noSideBar />
                <Header
                    noSideBar
                    onNote={() => onClick("chatbox")}
                    onNotification={() => onClick("notification")}
                    onProfile={() => onClick("profile")}
                    toggle={toggle}
                    title={title}
                    onBox={() => onClick("box")}
                />
                <ChatBox onClick={() => onClick("chatbox")} toggle={toggle} />
            </Fragment>
        )
    }
   return (
      <Fragment>
         <NavHader />
         <SideBar />
         <Header
            onNote={() => onClick("chatbox")}
            onNotification={() => onClick("notification")}
            onProfile={() => onClick("profile")}
            toggle={toggle}
            title={title}
            onBox={() => onClick("box")}
         />
         <ChatBox onClick={() => onClick("chatbox")} toggle={toggle} />
      </Fragment>
   );
};

export default JobieNav;
